import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaImages, FaLayerGroup, FaMapMarkerAlt, FaSearch } from 'react-icons/fa';
import {
  getNeighborhoodDevelopments,
  getIskenderunNeighborhoods,
  getIskenderunStreets
} from '../../api/neighborhoodService';

export const fallbackMahalleler = [
  { id: 1, name: 'Barbaros Mahallesi', image: '/assets/images/mahalleler/barbaros/1.jpg', urlTag: 'barbaros', totalImages: 5 },
  { id: 2, name: 'Cumhuriyet Mahallesi', image: '/assets/images/mahalleler/cumhuriyet/1.jpg', urlTag: 'cumhuriyet', totalImages: 2 },
  { id: 3, name: 'Denizciler Mahallesi', image: '/assets/images/mahalleler/denizciler/1.jpg', urlTag: 'denizciler', totalImages: 2 },
  { id: 4, name: 'Gültepe Mahallesi', image: '/assets/images/mahalleler/gultepe/1.jpg', urlTag: 'gultepe', totalImages: 14 },
  { id: 5, name: 'İsmet İnönü Mahallesi', image: '/assets/images/mahalleler/ismet-inonu/1.jpg', urlTag: 'ismet-inonu', totalImages: 1 },
  { id: 6, name: 'Akçay Mahallesi', image: '/assets/images/mahalleler/akcay/1.jpg', urlTag: 'akcay', totalImages: 1 },
  { id: 7, name: 'Azganlık Mahallesi', image: '/assets/images/mahalleler/azganlik/1.jpg', urlTag: 'azganlik', totalImages: 1 },
  { id: 8, name: 'Aşkarbeyli Mahallesi', image: '/assets/images/mahalleler/askarbeyli/1.jpg', urlTag: 'askarbeyli', totalImages: 1 },
  { id: 9, name: 'Bekbele Mahallesi', image: '/assets/images/mahalleler/bekbele/1.jpg', urlTag: 'bekbele', totalImages: 1 },
  { id: 10, name: 'Büyükdere Mahallesi', image: '/assets/images/mahalleler/buyukdere/1.jpg', urlTag: 'buyukdere', totalImages: 1 },
  { id: 11, name: 'Cebike Mahallesi', image: '/assets/images/mahalleler/cebike/1.jpg', urlTag: 'cebike', totalImages: 1 },
  { id: 12, name: 'Dumlupınar Mahallesi', image: '/assets/images/mahalleler/dumlupinar/1.jpg', urlTag: 'dumlupinar', totalImages: 1 },
  { id: 13, name: 'Esentepe Mahallesi', image: '/assets/images/mahalleler/esentepe/1.jpg', urlTag: 'esentepe', totalImages: 1 },
  { id: 14, name: 'Fatih Sultan Mehmet Mahallesi', image: '/assets/images/mahalleler/fatih-sultan-mehmet/1.jpg', urlTag: 'fatih-sultan-mehmet', totalImages: 1 },
  { id: 15, name: 'Gürsel Mahallesi', image: '/assets/images/mahalleler/gursel/1.jpg', urlTag: 'gursel', totalImages: 1 },
  { id: 16, name: 'Kocatepe Mahallesi', image: '/assets/images/mahalleler/kocatepe/1.jpg', urlTag: 'kocatepe', totalImages: 1 },
  { id: 17, name: 'Numune Mahallesi', image: '/assets/images/mahalleler/numune/1.jpg', urlTag: 'numune', totalImages: 1 },
  { id: 18, name: 'Sariseki Mahallesi', image: '/assets/images/mahalleler/sariseki/1.jpg', urlTag: 'sariseki', totalImages: 1 },
  { id: 19, name: 'Süleymaniye Mahallesi', image: '/assets/images/mahalleler/suleymaniye/1.jpg', urlTag: 'suleymaniye', totalImages: 1 },
  { id: 20, name: 'Çay Mahallesi', image: '/assets/images/mahalleler/cay/1.jpg', urlTag: 'cay', totalImages: 1 }
];

const getImageUrl = (url) => {
  if (!url) return '/assets/images/default-image.jpg';
  if (url.startsWith('http')) return url;
  if (url.startsWith('/assets/')) return `https://iskenderun.bel.tr${url}`;
  if (url.startsWith('/uploads/')) {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://api.iskenderun.bel.tr/api';
    const apiDomain = apiUrl.endsWith('/api') ? apiUrl.slice(0, -4) : apiUrl;
    return `${apiDomain}${url}`;
  }
  return `https://iskenderun.bel.tr${url.startsWith('/') ? url : `/${url}`}`;
};

const resolveCoverImage = (mahalle) => {
  if (mahalle.coverImage) return getImageUrl(mahalle.coverImage);
  if (Array.isArray(mahalle.categories) && mahalle.categories.length > 0) {
    const sortedCategories = [...mahalle.categories].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
    for (const category of sortedCategories) {
      if (Array.isArray(category.images) && category.images.length > 0) {
        return getImageUrl(category.images[0].imageUrl);
      }
    }
  }
  if (Array.isArray(mahalle.images) && mahalle.images.length > 0) {
    return getImageUrl(mahalle.images[0].imageUrl || mahalle.images[0].src);
  }
  return mahalle.image || '/assets/images/default-image.jpg';
};

const normalizeStreet = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .replace(/i̇/g, 'i')
    .replace(/\./g, '')
    .replace(/\s+/g, ' ')
    .trim();
};

const Mahalleler = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [neighborhoodOptions, setNeighborhoodOptions] = useState([]);
  const [streetOptions, setStreetOptions] = useState([]);
  const [selectedNeighborhood, setSelectedNeighborhood] = useState('');
  const [selectedStreet, setSelectedStreet] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const [modalCategory, setModalCategory] = useState(null);
  const [modalMahalle, setModalMahalle] = useState(null);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  useEffect(() => {
    async function loadAddressData() {
      const nList = await getIskenderunNeighborhoods();
      setNeighborhoodOptions(nList || []);
    }
    loadAddressData();
  }, []);

  // Mahalle dropdown seçimi değiştiğinde otomatik sokakları ve o mahallenin verilerini getir
  useEffect(() => {
    if (!selectedNeighborhood) {
      setStreetOptions([]);
      setSelectedStreet('');
      setHasSearched(false);
      setData([]);
      return;
    }
    async function loadStreetsAndData() {
      const sList = await getIskenderunStreets(selectedNeighborhood);
      setStreetOptions(sList || []);

      setLoading(true);
      setHasSearched(true);
      try {
        const response = await getNeighborhoodDevelopments(selectedNeighborhood);
        if (response?.isSuccess && Array.isArray(response.data) && response.data.length > 0) {
          setData(response.data);
        } else {
          setData(fallbackMahalleler);
        }
      } catch (err) {
        console.error('Mahalle verisi çekilemedi, varsayılan liste yükleniyor.', err);
        setData(fallbackMahalleler);
      } finally {
        setLoading(false);
      }
    }
    loadStreetsAndData();
  }, [selectedNeighborhood]);

  const handleSearchSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setHasSearched(true);
    if (!selectedNeighborhood) return;

    setLoading(true);
    try {
      const response = await getNeighborhoodDevelopments(selectedNeighborhood);
      if (response?.isSuccess && Array.isArray(response.data) && response.data.length > 0) {
        setData(response.data);
      } else {
        setData(fallbackMahalleler);
      }
    } catch (err) {
      console.error('Mahalle verisi çekilemedi, varsayılan liste yükleniyor.', err);
      setData(fallbackMahalleler);
    } finally {
      setLoading(false);
    }
  };

  const filteredData = useMemo(() => {
    if (!selectedNeighborhood && !hasSearched) {
      return [];
    }
    let result = data.length > 0 ? data : fallbackMahalleler;
    result = result.filter(item => item.isApproved !== false);

    if (selectedNeighborhood) {
      const cleanSelected = selectedNeighborhood.replace(/ Mahallesi/i, '').toLowerCase().replace(/i̇/g, 'i').trim();
      result = result.filter(item => {
        if (!item.name) return false;
        const cleanItemName = item.name.replace(/ Mahallesi/i, '').toLowerCase().replace(/i̇/g, 'i').trim();
        return cleanItemName === cleanSelected;
      });
    }

    if (selectedStreet) {
      const cleanSelectedStreet = normalizeStreet(selectedStreet);
      const streetNumMatch = cleanSelectedStreet.match(/\d+/);
      const streetNum = streetNumMatch ? streetNumMatch[0] : null;

      result = result.filter(item => {
        const itemStreet = normalizeStreet(item.sokakName);
        const itemTitle = normalizeStreet(item.title);
        const itemDesc = normalizeStreet(item.description);

        const isMatch = (str) => {
          if (!str) return false;
          if (str === cleanSelectedStreet || str.includes(cleanSelectedStreet) || cleanSelectedStreet.includes(str)) return true;
          if (streetNum && (str.includes(`${streetNum} sk`) || str.includes(`${streetNum} sokak`) || str.includes(`${streetNum} sok`) || str.includes(streetNum))) return true;
          return false;
        };

        if (isMatch(itemStreet) || isMatch(itemTitle) || isMatch(itemDesc)) return true;

        if (Array.isArray(item.categories)) {
          return item.categories.some(cat => {
            const catStreet = normalizeStreet(cat.sokakName);
            const catName = normalizeStreet(cat.name);
            const catDesc = normalizeStreet(cat.description);
            return isMatch(catStreet) || isMatch(catName) || isMatch(catDesc);
          });
        }
        return false;
      });
    }
    return result;
  }, [data, selectedNeighborhood, selectedStreet, hasSearched]);

  const summary = useMemo(() => {
    return {
      totalNeighborhoods: filteredData.length,
      totalImages: filteredData.reduce((sum, item) => sum + (item.totalImages || 0), 0)
    };
  }, [filteredData]);

  const openCardModal = (cat, mahalle) => {
    setModalCategory(cat);
    setModalMahalle(mahalle);
    setActiveImageIndex(0);
  };

  const closeModal = () => {
    setModalCategory(null);
    setModalMahalle(null);
  };

  return (
    <div className="mahalleler-page py-3">
      <div className="container" style={{ maxWidth: '1100px' }}>
        <div className="col-md-12">
          <section className="mahalle-hero mb-3">
            <div className="mahalle-hero__content">
              <span className="mahalle-hero__eyebrow">
                <FaLayerGroup className="me-1" style={{ fontSize: '0.85rem' }} />
                Sahadan Güncel Çalışmalar
              </span>
              <h1 className="page-title fw-bold">Mahallem Gelişiyor</h1>
              <p className="mahalle-hero__description">
                İskenderun’un mahallelerinde yürütülen projeleri ve sokak düzenlemelerini detaylı olarak inceleyebilirsiniz.
              </p>
            </div>
          </section>

          <div className="mahalle-filter-card">
            <div className="row g-3 align-items-stretch">
              {/* Mahalle Seçimi */}
              <div className="col-12 col-md-6">
                <div
                  style={{
                    backgroundColor: '#f8fafd',
                    border: '1.5px solid #d0e4f5',
                    borderRadius: '14px',
                    padding: '12px 16px'
                  }}
                >
                  <label
                    className="d-flex align-items-center gap-2 mb-2"
                    style={{ fontSize: '0.82rem', fontWeight: 700, color: '#0f75bc', letterSpacing: '0.04em', textTransform: 'uppercase' }}
                  >
                    <span
                      style={{
                        width: 28, height: 28, borderRadius: '8px',
                        backgroundColor: 'rgba(15, 117, 188, 0.1)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0
                      }}
                    >
                      <FaMapMarkerAlt style={{ fontSize: '0.75rem', color: '#0f75bc' }} />
                    </span>
                    Mahalle Seçiniz
                  </label>
                  <select
                    className="form-select-custom"
                    style={{ borderRadius: '10px', height: '44px', fontSize: '0.95rem', background: '#fff', border: '1.5px solid #d0e4f5' }}
                    value={selectedNeighborhood}
                    onChange={(e) => {
                      setSelectedNeighborhood(e.target.value);
                      setSelectedStreet('');
                    }}
                  >
                    <option value="">-- Mahalle Seçiniz --</option>
                    {neighborhoodOptions.map((n) => (
                      <option key={n} value={n}>{n}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Sokak / Cadde Seçimi */}
              <div className="col-12 col-md-6">
                <div
                  style={{
                    backgroundColor: selectedNeighborhood ? '#f8fafd' : '#f1f5f9',
                    border: `1.5px solid ${selectedNeighborhood ? '#d0e4f5' : '#e2e8f0'}`,
                    borderRadius: '14px',
                    padding: '12px 16px',
                    transition: 'all 0.2s ease'
                  }}
                >
                  <label
                    className="d-flex align-items-center gap-2 mb-2"
                    style={{ fontSize: '0.82rem', fontWeight: 700, color: selectedNeighborhood ? '#0f75bc' : '#94a3b8', letterSpacing: '0.04em', textTransform: 'uppercase' }}
                  >
                    <span
                      style={{
                        width: 28, height: 28, borderRadius: '8px',
                        backgroundColor: selectedNeighborhood ? 'rgba(15, 117, 188, 0.1)' : 'rgba(148, 163, 184, 0.15)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0
                      }}
                    >
                      <FaSearch style={{ fontSize: '0.7rem', color: selectedNeighborhood ? '#0f75bc' : '#94a3b8' }} />
                    </span>
                    Sokak / Cadde Seçiniz
                    {!selectedNeighborhood && (
                      <span style={{ fontSize: '0.72rem', color: '#94a3b8', fontWeight: 500, textTransform: 'none', letterSpacing: 0 }}>
                        — önce mahalle seçin
                      </span>
                    )}
                  </label>
                  <select
                    className="form-select-custom"
                    style={{
                      borderRadius: '10px', height: '44px', fontSize: '0.95rem',
                      background: selectedNeighborhood ? '#fff' : '#f1f5f9',
                      border: `1.5px solid ${selectedNeighborhood ? '#d0e4f5' : '#e2e8f0'}`
                    }}
                    value={selectedStreet}
                    onChange={(e) => setSelectedStreet(e.target.value)}
                    disabled={!selectedNeighborhood}
                  >
                    <option value="">-- Tüm Sokaklar / Caddeler --</option>
                    {streetOptions.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>



          {loading ? (
            <div className="d-flex justify-content-center py-4">
              <div className="spinner-border text-primary" role="status"></div>
            </div>
          ) : !hasSearched && !selectedNeighborhood ? (
            <div>
              <div
                className="d-none d-md-flex align-items-center flex-wrap gap-3 justify-content-between mb-4 p-3 px-3 rounded-4 shadow-sm border-0"
                style={{
                  background: 'linear-gradient(90deg, #ffffff 0%, #f4f8fc 100%)',
                  borderLeft: '5px solid #0f75bc'
                }}
              >
                <div className="d-flex align-items-center gap-3">
                  <div
                    style={{
                      width: '46px',
                      height: '46px',
                      borderRadius: '14px',
                      backgroundColor: 'rgba(15, 117, 188, 0.1)',
                      color: '#0f75bc',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.2rem'
                    }}
                  >
                    <FaMapMarkerAlt />
                  </div>
                  <div>
                    <h5 className="fw-bold mb-0 text-dark" style={{ fontSize: '1.15rem' }}>İskenderun Mahalleleri</h5>
                    <small className="text-secondary fw-semibold">
                      Çalışmaları incelemek için listelenen bir mahalleye tıklayabilirsiniz
                    </small>
                  </div>
                </div>
                <span className="badge rounded-pill bg-primary bg-opacity-10 text-primary px-3 py-2 fw-bold" style={{ fontSize: '0.82rem' }}>
                  {neighborhoodOptions.length || fallbackMahalleler.length} Mahalle Bulundu
                </span>
              </div>
              {/* Mobilde sadece hint göster, masaüstünde kart ızgarası */}
              <div className="d-md-none mb-3">
                <div
                  style={{
                    background: 'linear-gradient(135deg, rgba(15,117,188,0.06) 0%, rgba(15,117,188,0.02) 100%)',
                    border: '1.5px dashed rgba(15,117,188,0.25)',
                    borderRadius: '16px',
                    padding: '20px 18px',
                    textAlign: 'center'
                  }}
                >
                  <div
                    style={{
                      width: 44, height: 44, borderRadius: '12px',
                      backgroundColor: 'rgba(15,117,188,0.1)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      margin: '0 auto 12px'
                    }}
                  >
                    <FaMapMarkerAlt style={{ color: '#0f75bc', fontSize: '1.1rem' }} />
                  </div>
                  <p className="fw-bold text-dark mb-1" style={{ fontSize: '0.95rem' }}>Mahalle Seçin</p>
                  <p className="text-secondary mb-0" style={{ fontSize: '0.82rem', lineHeight: 1.55 }}>
                    Yukarıdaki menüden bir mahalle seçerek o mahalledeki çalışmaları görüntüleyebilirsiniz.
                  </p>
                </div>
              </div>

              {/* Masaüstü kart ızgarası */}
              <div className="d-none d-md-block">
                <div className="row g-4 gy-5 mb-5">
                  {(neighborhoodOptions.length > 0 ? neighborhoodOptions : fallbackMahalleler.map(m => m.name)).map((mName, idx) => {
                    const fallbackItem = fallbackMahalleler.find(f => f.name.toLowerCase().includes(mName.replace(' Mahallesi', '').toLowerCase())) || fallbackMahalleler[idx % fallbackMahalleler.length];
                    const imgUrl = fallbackItem?.image ? getImageUrl(fallbackItem.image) : '/assets/images/default-image.jpg';

                    return (
                      <div key={mName || idx} className="col-12 col-sm-6 col-xl-4" style={{ paddingBottom: '24px' }}>
                        <div
                          className="mahalle-card shadow-sm h-100"
                          style={{ cursor: 'pointer' }}
                          onClick={async () => {
                            setSelectedNeighborhood(mName);
                            setHasSearched(true);
                            setLoading(true);
                            try {
                              const response = await getNeighborhoodDevelopments(mName);
                              if (response?.isSuccess && Array.isArray(response.data) && response.data.length > 0) {
                                setData(response.data);
                              } else {
                                setData(fallbackMahalleler);
                              }
                            } catch (err) {
                              setData(fallbackMahalleler);
                            } finally {
                              setLoading(false);
                            }
                          }}
                        >
                          <div className="mahalle-card-image" style={{ height: '220px' }}>
                            <img src={imgUrl} alt={mName} />
                          </div>
                          <div className="mahalle-card-content p-3">
                            <h4 className="fw-bold text-dark mb-2" style={{ fontSize: '1.2rem' }}>{mName}</h4>
                            <p className="text-secondary small mb-0">
                              Mahalledeki sahadan çalışma görsellerini ve sokak düzenlemelerini incelemek için tıklayınız.
                            </p>
                            <div className="mahalle-card-footer mt-auto pt-3">
                              <span className="text-primary">Çalışmaları Görüntüle</span>
                              <FaArrowRight className="text-primary" />
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : filteredData.length === 0 ? (
            <div className="empty-state-card" style={{ padding: '40px 24px' }}>
              <div className="empty-icon text-secondary" style={{ background: 'rgba(100,116,139,0.1)' }}>
                <FaSearch />
              </div>
              <h4>Kayıt Bulunamadı</h4>
              <p>Seçtiğiniz <strong>{selectedNeighborhood}</strong> {selectedStreet ? `(${selectedStreet})` : ''} için henüz eklenmiş bir çalışma görseli bulunmamaktadır.</p>
              <button
                className="btn btn-primary mt-3 px-4 py-2 rounded-pill fw-bold shadow-sm"
                style={{ backgroundColor: '#0f75bc', borderColor: '#0f75bc', cursor: 'pointer' }}
                onClick={() => {
                  setSelectedNeighborhood('');
                  setSelectedStreet('');
                  setHasSearched(false);
                  setData([]);
                }}
              >
                ← Tüm Mahallelere Dön
              </button>
            </div>
          ) : (
            <div>
              {selectedNeighborhood && (
                <div
                  className="d-none d-md-flex align-items-center flex-wrap gap-3 justify-content-between mb-4 p-3 px-3 rounded-4 shadow-sm border-0"
                  style={{
                    background: 'linear-gradient(90deg, #ffffff 0%, #f4f8fc 100%)',
                    borderLeft: '5px solid #0f75bc'
                  }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <div
                      style={{
                        width: '46px',
                        height: '46px',
                        borderRadius: '14px',
                        backgroundColor: 'rgba(15, 117, 188, 0.1)',
                        color: '#0f75bc',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.2rem'
                      }}
                    >
                      <FaMapMarkerAlt />
                    </div>
                    <div>
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <h5 className="fw-bold mb-0 text-dark" style={{ fontSize: '1.15rem' }}>{selectedNeighborhood}</h5>
                        <span className="badge rounded-pill bg-primary bg-opacity-10 text-primary px-3 py-1 fw-bold" style={{ fontSize: '0.75rem' }}>
                          {filteredData.length} Kayıt Bulundu
                        </span>
                      </div>
                      <small className="text-secondary fw-semibold">
                        {selectedStreet ? `Sokak / Cadde: ${selectedStreet}` : 'Mahalleye ait tüm sokak ve bölge düzenlemeleri'}
                      </small>
                    </div>
                  </div>
                  <button
                    className="btn btn-outline-primary rounded-pill px-4 py-2 fw-bold btn-sm shadow-sm"
                    style={{
                      color: '#0f75bc',
                      borderColor: '#0f75bc',
                      backgroundColor: '#ffffff',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                    onClick={() => {
                      setSelectedNeighborhood('');
                      setSelectedStreet('');
                      setHasSearched(false);
                      setData([]);
                    }}
                  >
                    ← Tüm Mahallelere Dön
                  </button>
                </div>
              )}
              <div className="row g-4 gy-5 mb-5">
                {filteredData.flatMap((mahalle, mIndex) => {
                  let categories = Array.isArray(mahalle.categories) && mahalle.categories.length > 0
                    ? mahalle.categories
                    : (mahalle.images && mahalle.images.length > 0 ? [{ guid: `cat-genel-${mIndex}`, name: mahalle.title || 'Genel Çalışma', description: mahalle.description, images: mahalle.images }] : []);

                  if (selectedStreet) {
                    const cleanSelected = normalizeStreet(selectedStreet);
                    const streetNumMatch = cleanSelected.match(/\d+/);
                    const streetNum = streetNumMatch ? streetNumMatch[0] : null;

                    const isMatch = (str) => {
                      if (!str) return false;
                      if (str === cleanSelected || str.includes(cleanSelected) || cleanSelected.includes(str)) return true;
                      if (streetNum && (str.includes(`${streetNum} sk`) || str.includes(`${streetNum} sokak`) || str.includes(`${streetNum} sok`) || str.includes(streetNum))) return true;
                      return false;
                    };

                    categories = categories.filter(cat => {
                      const catStreet = normalizeStreet(cat.sokakName);
                      const catName = normalizeStreet(cat.name);
                      const catDesc = normalizeStreet(cat.description);
                      const mahalleStreet = normalizeStreet(mahalle.sokakName);
                      const mahalleTitle = normalizeStreet(mahalle.title);
                      return isMatch(catStreet) || isMatch(catName) || isMatch(catDesc) || isMatch(mahalleStreet) || isMatch(mahalleTitle);
                    });
                  }

                  // Görseli / Fotoğrafı olmayan veya yalnızca 1 görsel içeren 'Genel' kapak fotoğrafı kartlarını gizle
                  categories = categories.filter(cat => {
                    if (!Array.isArray(cat.images) || cat.images.length === 0) return false;
                    const nameLower = (cat.name || '').trim().toLowerCase();
                    const isGenelTitle = nameLower === 'genel' || nameLower === 'genel çalışma' || nameLower === 'genel calisma';
                    if (isGenelTitle && cat.images.length <= 1) return false;
                    return true;
                  });

                  return categories.map((cat, cIndex) => {
                    const coverImg = getImageUrl(cat.images[0].imageUrl);
                    const imageCount = cat.images.length;

                    return (
                      <div key={cat.guid || `cat-${mIndex}-${cIndex}`} className="col-12 col-sm-6 col-xl-4" style={{ paddingBottom: '24px' }}>
                        <div
                          className="mahalle-card shadow-sm h-100"
                          style={{ cursor: 'pointer' }}
                          onClick={() => openCardModal(cat, mahalle)}
                        >
                          <div className="mahalle-card-image">
                            <img src={coverImg} alt={cat.name} />
                            <div className="mahalle-card-badge">
                              <FaImages />
                              <span>{imageCount} fotoğraf</span>
                            </div>
                            {(() => {
                              const badgeText = cat.sokakName || selectedStreet;
                              const isUnknown = !badgeText || ['belirtilmedi', 'bilinmiyor', 'belirsiz', 'yok', 'tanımsız', 'null', 'undefined'].includes(badgeText.trim().toLowerCase());
                              return !isUnknown ? (
                                <div className="sokak-badge">
                                  {badgeText}
                                </div>
                              ) : null;
                            })()}
                          </div>
                          <div className="mahalle-card-content">
                            <h3>{cat.name}</h3>
                            {cat.description && (
                              <p className="text-secondary small mb-0">
                                {cat.description.length > 90 ? `${cat.description.substring(0, 90)}...` : cat.description}
                              </p>
                            )}
                            <div className="mahalle-card-footer mt-auto pt-3">
                              <span>Düzenleme ve Görselleri İncele</span>
                              <FaArrowRight />
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  });
                })}
              </div>
            </div>
          )}
        </div>
      </div>

      {modalCategory && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(15, 23, 42, 0.75)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 'clamp(0px, 3vw, 24px)',
            WebkitOverflowScrolling: 'touch'
          }}
          onClick={closeModal}
        >
          <div
            style={{
              backgroundColor: '#ffffff',
              color: '#0f172a',
              borderRadius: 'clamp(12px, 3vw, 24px)',
              maxWidth: '920px',
              width: '100%',
              maxHeight: 'min(92vh, 100%)',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 25px 70px rgba(15, 23, 42, 0.22)',
              border: '1px solid rgba(226, 232, 240, 0.8)',
              overflow: 'hidden',
              position: 'relative'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Light Header */}
            <div
              style={{
                padding: '20px 28px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: '1px solid #e2e8f0',
                background: 'linear-gradient(135deg, #0f75bc 0%, #0a5587 100%)',
                color: '#ffffff'
              }}
            >
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    color: '#ffffff',
                    fontSize: '0.72rem',
                    fontWeight: 700,
                    padding: '4px 12px',
                    borderRadius: '999px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>
                    {selectedNeighborhood}
                  </span>
                  {modalCategory.sokakName && !['belirsiz', 'belirtilmedi', 'bilinmiyor', 'yok', 'tanımsız', 'null', 'undefined'].includes(modalCategory.sokakName.trim().toLowerCase()) && (
                    <span style={{
                      backgroundColor: 'rgba(255,255,255,0.15)',
                      color: '#ffffff',
                      fontSize: '0.72rem',
                      fontWeight: 600,
                      padding: '4px 12px',
                      borderRadius: '999px'
                    }}>
                      {modalCategory.sokakName}
                    </span>
                  )}
                </div>
                <h4 style={{ margin: '8px 0 0', fontWeight: 800, fontSize: '1.35rem', color: '#ffffff' }}>
                  {modalCategory.name}
                </h4>
              </div>
              <button
                type="button"
                onClick={closeModal}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  border: 'none',
                  color: '#fff',
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.1rem',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(239,68,68,0.9)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
              >
                ✕
              </button>
            </div>

            {/* Modal Body (Light Theme) */}
            <div style={{ padding: '24px', overflowY: 'auto', flex: 1, backgroundColor: '#ffffff', willChange: 'scroll-position', WebkitOverflowScrolling: 'touch' }}>
              {Array.isArray(modalCategory.images) && modalCategory.images.length > 0 ? (
                <div>
                  {/* Photo Display Stage (Clean Soft Backdrop) */}
                  <div
                    style={{
                      position: 'relative',
                      height: '460px',
                      backgroundColor: '#f8fafc',
                      borderRadius: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden',
                      border: '1px solid #e2e8f0'
                    }}
                  >
                    <img
                      src={getImageUrl(modalCategory.images[activeImageIndex]?.imageUrl)}
                      alt={modalCategory.name}
                      style={{
                        maxHeight: '100%',
                        maxWidth: '100%',
                        objectFit: 'contain'
                      }}
                    />

                    {/* Navigation Buttons */}
                    {modalCategory.images.length > 1 && (
                      <>
                        <button
                          type="button"
                          onClick={() => setActiveImageIndex((prev) => (prev > 0 ? prev - 1 : modalCategory.images.length - 1))}
                          style={{
                            position: 'absolute',
                            left: '16px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            border: '1px solid #cbd5e1',
                            color: '#0f172a',
                            width: '42px',
                            height: '42px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1.3rem',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            transition: 'all 0.2s ease'
                          }}
                        >
                          ‹
                        </button>
                        <button
                          type="button"
                          onClick={() => setActiveImageIndex((prev) => (prev < modalCategory.images.length - 1 ? prev + 1 : 0))}
                          style={{
                            position: 'absolute',
                            right: '16px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            border: '1px solid #cbd5e1',
                            color: '#0f172a',
                            width: '42px',
                            height: '42px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1.3rem',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            transition: 'all 0.2s ease'
                          }}
                        >
                          ›
                        </button>
                      </>
                    )}

                    {/* Counter Badge */}
                    <div style={{
                      position: 'absolute',
                      bottom: '16px',
                      right: '16px',
                      backgroundColor: 'rgba(15, 23, 42, 0.8)',
                      color: '#ffffff',
                      padding: '6px 14px',
                      borderRadius: '999px',
                      fontSize: '0.82rem',
                      fontWeight: 700
                    }}>
                      {activeImageIndex + 1} / {modalCategory.images.length}
                    </div>
                  </div>

                  {/* Thumbnails Row */}
                  {modalCategory.images.length > 1 && (
                    <div style={{ display: 'flex', gap: '12px', overflowX: 'auto', marginTop: '16px', paddingBottom: '4px' }}>
                      {modalCategory.images.map((img, idx) => (
                        <div
                          key={img.guid || idx}
                          onClick={() => setActiveImageIndex(idx)}
                          style={{
                            width: '84px',
                            height: '60px',
                            borderRadius: '12px',
                            overflow: 'hidden',
                            cursor: 'pointer',
                            flexShrink: 0,
                            border: activeImageIndex === idx ? '3px solid #0f75bc' : '2px solid #e2e8f0',
                            opacity: activeImageIndex === idx ? 1 : 0.6,
                            transition: 'all 0.2s ease',
                            transform: activeImageIndex === idx ? 'scale(1.04)' : 'none'
                          }}
                        >
                          <img
                            src={getImageUrl(img.imageUrl)}
                            alt={`Görsel ${idx + 1}`}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <div style={{ padding: '40px 20px', textAlign: 'center', backgroundColor: '#f8fafc', borderRadius: '16px', color: '#64748b' }}>
                  <FaImages size={40} style={{ marginBottom: '12px', color: '#0f75bc' }} />
                  <p style={{ margin: 0, fontWeight: 600 }}>Bu düzenleme projesine henüz görsel eklenmemiştir.</p>
                </div>
              )}

              {/* Work Description Box */}
              <div style={{
                marginTop: '20px',
                padding: '20px',
                backgroundColor: '#f8fafc',
                borderRadius: '16px',
                border: '1px solid #e2e8f0'
              }}>
                <h6 style={{ fontWeight: 700, color: '#0f75bc', marginBottom: '8px', fontSize: '0.92rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                  Çalışma / Düzenleme Detayı
                </h6>
                <p style={{ color: '#334155', margin: 0, lineHeight: 1.65, fontSize: '0.96rem' }}>
                  {modalCategory.description || modalMahalle?.description || 'Bu çalışma noktası için ek bir detay açıklaması bulunmamaktadır.'}
                </p>
              </div>
            </div>

            {/* Light Footer */}
            <div style={{
              padding: '16px 28px',
              borderTop: '1px solid #e2e8f0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: '#f8fafc'
            }}>
              <span style={{ fontSize: '0.85rem', color: '#64748b', fontWeight: 600 }}>
                İskenderun Belediyesi • Mahallem Gelişiyor Projesi
              </span>
              <button
                type="button"
                onClick={closeModal}
                style={{
                  padding: '10px 28px',
                  borderRadius: '12px',
                  backgroundColor: '#0f75bc',
                  color: '#ffffff',
                  border: 'none',
                  fontWeight: 700,
                  fontSize: '0.95rem',
                  cursor: 'pointer',
                  boxShadow: '0 4px 14px rgba(15, 117, 188, 0.3)',
                  transition: 'all 0.2s ease'
                }}
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Mahalleler;
